import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import { memo, createElement } from '@max/max';
import Image from '@hfe/max-image';
import '../calendar.scss';
import dayjs from 'dayjs';
import { DateShortcutType, TooltipType } from '../types';
const isMRN = false;
const CalendarDayItem = props => {
    var _a, _b, _c, _d, _e, _f, _g;
    /**
    * 选中某项
    */
    const selectItem = () => {
        if (props.value.disabled) {
            return;
        }
        props.onSyncSelection && props.onSyncSelection(props.value);
    };
    /**
    * 计算选中样式状态
    */
    const isSelected = () => {
        var _a;
        /**
         * 获取选中态的描述文字
         */
        const getDesc = (isStart, shortcutType, isBeforeDawn) => {
            var _a, _b;
            const actionDesc = isStart ? '入住' : '离店';
            const holidayType = (_b = (_a = holidayStatus === null || holidayStatus === void 0 ? void 0 : holidayStatus.details) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.holidayType;
            if (holidayType === 0 || holidayType === 3) {
                return `${holidayStatus.details[0].displayName}${actionDesc}`;
            }
            if (isBeforeDawn) {
                if (shortcutType === DateShortcutType.todayBeforeDawn) {
                    return `凌晨${actionDesc}`;
                }
                if (shortcutType === DateShortcutType.today) {
                    return `中午${actionDesc}`;
                }
            }
            else if (shortcutType === DateShortcutType.today) {
                return `今天${actionDesc}`;
            }
            if (shortcutType === DateShortcutType.tommorrow) {
                return `明天${actionDesc}`;
            }
            return actionDesc;
        };
        const result = {
            isStart: false,
            isEnd: false,
            isMiddle: false,
            middleRight: false,
            middleLeft: false,
            startSide: false,
            endSide: false,
            startDayDesc: '',
            endDayDesc: ''
        };
        if (!props.value || props.value.disabled) {
            return result;
        }
        const { startDay, endDay } = props.viewState;
        const curValue = dayjs((_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.value);
        let diffWithStartDay = 0;
        let diffWithEndDay = 0;
        if (startDay === null || startDay === void 0 ? void 0 : startDay.value) {
            // 判断是不是开始日期
            diffWithStartDay = curValue.diff(dayjs(startDay.value), 'days');
            if (diffWithStartDay === 0) {
                result.isStart = true;
                result.startDayDesc = getDesc(true, props.value.shortcutType, props.viewState.isBeforeDawn);
            }
        }
        if (endDay === null || endDay === void 0 ? void 0 : endDay.value) {
            diffWithEndDay = curValue.diff(dayjs(endDay.value), 'days');
            if (curValue.diff(dayjs(endDay.value)) === 0) {
                result.isEnd = true;
                result.endDayDesc = getDesc(false, props.value.shortcutType, props.viewState.isBeforeDawn);
            }
        }
        // 判断是不是中间的日期
        if (diffWithStartDay > 0 && diffWithEndDay < 0) {
            result.isMiddle = true;
            // 如果是最右侧的项，则右侧样式优先（不需要与结束日期衔接的样式）
            if (props.value.weekday === 6 || dayjs(props.value.value).add(1, 'days').month() !== props.value.month - 1) {
                result.middleRight = true;
            }
            else if (diffWithEndDay === -1) {
                result.endSide = true;
            }
            // 如果是最左侧的项，则最左侧的样式优先（不需要与开始日期衔接的样式）
            if (props.value.weekday === 0 || props.value.day === 1) {
                result.middleLeft = true;
            }
            else if (diffWithStartDay === 1) {
                result.startSide = true;
            }
        }
        return result;
    };
    /**
    * 获取假期的特殊描述文字
    */
    const getHolidayStatus = () => {
        if (!(props === null || props === void 0 ? void 0 : props.holidayState) || !(props === null || props === void 0 ? void 0 : props.value)) {
            return null;
        }
        return props.holidayState[props.value.indexKey];
    };
    const holidayStatus = getHolidayStatus();
    /**
     * 获取需要额外展示的描述文字
     */
    const getExtraTip = () => {
        var _a, _b, _c, _d, _e;
        if (selectStatus.isStart || selectStatus.isEnd) {
            return null;
        }
        const result = {
            text: '',
            holidayType: null
        };
        if ((_a = holidayStatus === null || holidayStatus === void 0 ? void 0 : holidayStatus.details) === null || _a === void 0 ? void 0 : _a[0]) {
            result.text = holidayStatus.details[0].displayName;
            result.holidayType = holidayStatus.details[0].holidayType;
        }
        else if (((_b = props === null || props === void 0 ? void 0 : props.value) === null || _b === void 0 ? void 0 : _b.shortcutType) === DateShortcutType.today) {
            if ((_c = props === null || props === void 0 ? void 0 : props.viewState) === null || _c === void 0 ? void 0 : _c.isBeforeDawn) {
                result.text = '今天中午';
            }
            else {
                result.text = '今天';
            }
        }
        else if (((_d = props === null || props === void 0 ? void 0 : props.value) === null || _d === void 0 ? void 0 : _d.shortcutType) === DateShortcutType.tommorrow) {
            result.text = '明天';
        }
        else if (((_e = props === null || props === void 0 ? void 0 : props.value) === null || _e === void 0 ? void 0 : _e.shortcutType) === DateShortcutType.todayBeforeDawn) {
            result.text = '今天凌晨';
        }
        return result;
    };
    /**
    * 获取tooltip样式
    */
    const getTooltipStatus = () => {
        const { startDay, endDay, isBeforeDawn } = (props === null || props === void 0 ? void 0 : props.viewState) || {};
        if (!selectStatus.isStart) {
            return {
                type: TooltipType.none,
                isShow: false
            };
        }
        if ((startDay === null || startDay === void 0 ? void 0 : startDay.value) && !(endDay === null || endDay === void 0 ? void 0 : endDay.value)) {
            return {
                type: TooltipType.invalid,
                isShow: true,
                weekday: startDay.weekday
            };
        }
        if (isBeforeDawn && startDay.shortcutType === DateShortcutType.todayBeforeDawn) {
            return {
                type: TooltipType.dawn,
                isShow: true,
                weekday: startDay.weekday
            };
        }
        if (isBeforeDawn && startDay.shortcutType === DateShortcutType.today) {
            return {
                type: TooltipType.dawnNoon,
                isShow: true,
                weekday: startDay.weekday
            };
        }
        return {
            type: TooltipType.none,
            isShow: false
        };
    };
    /**
     * 同步凌晨入住弹窗状态
     */
    const onSyncStorage = (type, value) => {
        props.onSyncStorage(type, value);
    };
    const selectStatus = isSelected();
    const extraTip = getExtraTip();
    const tooltipStatus = getTooltipStatus();
    let dateDesc = props.value.day;
    const { isBeforeDawn } = (props === null || props === void 0 ? void 0 : props.viewState) || {};
    if (isBeforeDawn && ((_a = props.value) === null || _a === void 0 ? void 0 : _a.shortcutType) === DateShortcutType.todayBeforeDawn) {
        const tomorrow = new Date((_b = props.value) === null || _b === void 0 ? void 0 : _b.value);
        tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
        dateDesc = dayjs(tomorrow).date();
    }
    return <View className={{
        'calendar-days-single-item-container': true,
        'calendar-days-single-item--disabled': (_c = props === null || props === void 0 ? void 0 : props.value) === null || _c === void 0 ? void 0 : _c.disabled,
        'calendar-days-single-item--selected': selectStatus.isStart || selectStatus.isEnd,
        'calendar-days-single-item--selected-start': selectStatus.isStart,
        'calendar-days-single-item--selected-middle': selectStatus.isMiddle,
        'calendar-days-single-item--selected-middle-right': selectStatus.middleRight,
        'calendar-days-single-item--selected-middle-left': selectStatus.middleLeft,
        'calendar-days-single-item--selected-middle-startside': selectStatus.startSide,
        'calendar-days-single-item--selected-middle-endside': selectStatus.endSide,
        'calendar-days-single-item--selected-middle-left-endside': selectStatus.middleLeft && selectStatus.endSide
    }} onClick={selectItem}>
      <View x-if={props.value && props.value.day} className="calendar-days-single-item">
        <View x-if={tooltipStatus.isShow} className={{
        'calendar-days-single-tooltip': true,
        'calendar-days-single-tooltip-invalid': tooltipStatus.type === TooltipType.invalid,
        'calendar-days-single-tooltip-dawn': tooltipStatus.type === TooltipType.dawn || tooltipStatus.type === TooltipType.dawnNoon,
        'calendar-days-single-tooltip--left': tooltipStatus.type === TooltipType.invalid && tooltipStatus.weekday === 0 || (tooltipStatus.type === TooltipType.dawn || tooltipStatus.type === TooltipType.dawnNoon) && tooltipStatus.weekday < 3,
        'calendar-days-single-tooltip--right': tooltipStatus.type === TooltipType.invalid && tooltipStatus.weekday === 6 || (tooltipStatus.type === TooltipType.dawn || tooltipStatus.type === TooltipType.dawnNoon) && tooltipStatus.weekday > 4
    }}>
          <View className={{
        'calendar-days-single-tooltip--triangle': true,
        'calendar-days-single-tooltip--triangle-left': tooltipStatus.type === TooltipType.invalid && tooltipStatus.weekday === 0 || (tooltipStatus.type === TooltipType.dawn || tooltipStatus.type === TooltipType.dawnNoon) && tooltipStatus.weekday < 3,
        'calendar-days-single-tooltip--triangle-right': tooltipStatus.type === TooltipType.invalid && tooltipStatus.weekday === 6 || (tooltipStatus.type === TooltipType.dawn || tooltipStatus.type === TooltipType.dawnNoon) && tooltipStatus.weekday > 4
    }}>
            <Image className="calendar-days-single-tooltip--triangle-img" source={{
        uri: 'https://p0.meituan.net/travelcube/52fa7ced0706175d3c4d5e5e1e5d01b6486.png'
    }}/>
          </View>
          <Text x-if={tooltipStatus.type === TooltipType.invalid} className="calendar-days-single-tooltip--container" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {}}>
            请选择离店时间
          </Text>
          <Text x-if={tooltipStatus.type === TooltipType.dawn || tooltipStatus.type === TooltipType.dawnNoon} numberOfLines={2} className="calendar-days-single-tooltip--container" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {}}>
            当前已过0点，{tooltipStatus.type === TooltipType.dawnNoon ? '如需今天凌晨' : '已选凌晨'}<Text className="calendar-days-single-tooltip--yellow" style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {}}>06:00</Text>前入住，{tooltipStatus.type === TooltipType.dawnNoon ? '请选择“今天凌晨”入住' : '中午离店，如需调整，请重新选择日期'}
          </Text>
          <Image x-if={tooltipStatus.type === TooltipType.dawn && (props === null || props === void 0 ? void 0 : props.isShowDawnTooltip)} className="calendar-days-single-tooltip--closebtn" source={{
        uri: 'https://p0.meituan.net/ingee/d99394fbacce92f9abee1707ba3690f7897.png'
    }} style={{
        pointerEvents: 'auto'
    }} onClick={() => {
        onSyncStorage('hotelCalendarTooltip__dawnTip', false);
    }}/>
        </View>
        <Text x-if={selectStatus.isStart} className={{
        'calendar-days-single-extra': true,
        'calendar-days-single-extra--small': ((_d = selectStatus === null || selectStatus === void 0 ? void 0 : selectStatus.startDayDesc) === null || _d === void 0 ? void 0 : _d.length) >= 4
    }} style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold',
        color: '#fff'
    } : {}}>
          {selectStatus.startDayDesc}
        </Text>
        <Text x-if={selectStatus.isEnd} className={{
        'calendar-days-single-extra': true,
        'calendar-days-single-extra--small': ((_e = selectStatus === null || selectStatus === void 0 ? void 0 : selectStatus.endDayDesc) === null || _e === void 0 ? void 0 : _e.length) > 4
    }} style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold',
        color: '#fff'
    } : {}}>
          {selectStatus.endDayDesc}
        </Text>
        <Text x-if={extraTip} className={{
        'calendar-days-single-extra': true,
        'calendar-days-single-extra--red': (extraTip === null || extraTip === void 0 ? void 0 : extraTip.holidayType) === 0 || (extraTip === null || extraTip === void 0 ? void 0 : extraTip.holidayType) === 1,
        'calendar-days-single-extra--blue': (extraTip === null || extraTip === void 0 ? void 0 : extraTip.holidayType) === 2,
        'calendar-days-single-extra--disabled': (_f = props === null || props === void 0 ? void 0 : props.value) === null || _f === void 0 ? void 0 : _f.disabled
    }} style={isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {}}>
          {extraTip.text}
        </Text>
        <Text className={{
        'calendar-days-single-main': true,
        'calendar-days-single-main--selected': selectStatus.isStart || selectStatus.isEnd
    }} style={Object.assign(Object.assign({}, (isMRN ? {
        fontFamily: 'MTNewDigitalDisplay-Bold'
    } : {})), {
        color: ((_g = props === null || props === void 0 ? void 0 : props.value) === null || _g === void 0 ? void 0 : _g.disabled) ? '#ccc' : selectStatus.isStart || selectStatus.isEnd ? '#fff' : '#000'
    })}>
          {dateDesc}
        </Text>
      </View>
    </View>;
};
export default memo(CalendarDayItem);
